import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Menu, X } from 'lucide-react';
import logoImage from '../assets/logo_small.png';

export const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Ensure dashboard is always in light mode
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="flex h-screen bg-gray-50 overflow-x-hidden">
      {/* Mobile Header */}
      <header className="fixed top-0 left-0 right-0 h-14 bg-gray-900 flex items-center justify-between px-4 z-40 md:hidden">
        <button
          onClick={toggleSidebar}
          className="p-2 -ml-2 text-white hover:bg-gray-800 rounded-lg transition-colors"
          aria-label="Toggle menu"
        >
          {isSidebarOpen ? (
            <X className="w-6 h-6" />
          ) : (
            <Menu className="w-6 h-6" />
          )}
        </button>
        <div className="flex items-center gap-2">
          <img
            src={logoImage}
            alt="Visto Logo"
            className="w-8 h-8 object-contain"
          />
          <span className="text-white font-bold text-lg">Visto</span>
        </div>
        <div className="w-10"></div> {/* Spacer for centering */}
      </header>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity"
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto overscroll-contain pt-14 md:pt-0 p-4 md:p-8 pb-safe min-h-0">
        <div className="pb-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
